import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { DateInput, EditBase, required } from "react-admin";
import { type DialogProps } from "../misc/DialogProps";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { Form2 } from "../misc/Form2";
import { Column } from "../misc/Column";
import { SaveButton2 } from "../buttons/SaveButton2";
import { Course } from "../providers/coursesProvider";
import { date, dateMaxYear, dateMinYear } from "../utils/validators";

export function EditCourseDialog({ course, ...dialogProps }: { course: Course } & DialogProps) {
  const { onClose: closeDialog } = dialogProps;

  return (
    <Dialog {...dialogProps} maxWidth="sm" fullWidth>
      <DialogTitle>Kurs bearbeiten</DialogTitle>
      <DialogCloseButton onClick={closeDialog} />
      <EditBase
        resource="courses"
        id={course.id}
        mutationMode="pessimistic"
        redirect={false}
        mutationOptions={{
          onSuccess: () => {
            showSuccessToast("Änderung(en) erfolgreich gespeichert.");
            void queryClient.invalidateQueries();
            closeDialog();
          },
          onError: (error) => handleError("Fehler beim Speichern.", error),
        }}
      >
        <Form2>
          <DialogContent>
            <Column>
              <DateInput
                label="Kursbeginn"
                source="start"
                validate={[required("Bitte wähle ein Datum aus."), date(), dateMinYear(2000), dateMaxYear(2099)]}
                fullWidth
              />
              <DateInput
                label="Kursende"
                source="end"
                validate={[required("Bitte wähle ein Datum aus."), date(), dateMinYear(2000), dateMaxYear(2099)]}
                fullWidth
              />
            </Column>
          </DialogContent>
          <DialogActions>
            <SaveButton2 label="Speichern" />
          </DialogActions>
        </Form2>
      </EditBase>
    </Dialog>
  );
}
